/**
 * YouTube Inline Video Component
 * Zeigt ein YouTube-Video inline mit automatischem Thumbnail
 */
(function() {
  'use strict';

  if (customElements.get('youtube-inline')) return;

  customElements.define('youtube-inline', class extends HTMLElement {
    constructor() {
      super();
      this.isPlaying = false;
      this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.videoId = this.getAttribute('data-video-id');
      this.autoplay = this.getAttribute('data-autoplay') === '1';
      
      this.poster = this.querySelector('[data-youtube-poster]');
      this.player = this.querySelector('[data-youtube-player]');
      this.playButton = this.querySelector('[data-youtube-play]');
      this.iframe = this.querySelector('[data-youtube-iframe]');

      if (this.autoplay) {
        this.initAutoplay();
      } else {
        this.initClickToPlay();
      }
    }

    initAutoplay() {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.isPlaying) {
            this.loadVideo();
          }
        });
      }, {
        root: null,
        rootMargin: '100px',
        threshold: 0.25
      });

      this.observer.observe(this);
    }

    initClickToPlay() {
      // Click handler für den Play-Button
      if (this.playButton) {
        this.playButton.addEventListener('click', this.handleClick);
      }

      // Click handler für das gesamte Poster
      if (this.poster) {
        this.poster.addEventListener('click', this.handleClick);
      }
    }

    handleClick(e) {
      e.preventDefault();
      e.stopPropagation();
      this.loadVideo();
    }

    loadVideo() {
      if (this.isPlaying) return;
      this.isPlaying = true;

      // Poster ausblenden
      if (this.poster) {
        this.poster.style.display = 'none';
      }

      // Player einblenden
      if (this.player) {
        this.player.style.display = 'block';
      }

      // Video laden
      if (this.iframe) {
        const src = this.iframe.getAttribute('data-src');
        if (src) {
          // Autoplay beim Klick immer aktivieren
          const finalSrc = src.includes('autoplay=0') 
            ? src.replace('autoplay=0', 'autoplay=1') 
            : src;
          this.iframe.setAttribute('src', finalSrc);
        }
      }
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
      
      // Event Listener entfernen
      if (this.playButton) {
        this.playButton.removeEventListener('click', this.handleClick);
      }
      if (this.poster) {
        this.poster.removeEventListener('click', this.handleClick);
      }
    }
  });
})();

